import cloneDeep from 'lodash/cloneDeep';
import widgetHelper from '../widget-utilities/widget-helper';

/* Config builder for Twobytwo chart */
var twobytwoConfigBuilder = function twobytwoConfigBuilder() {

    // Returns modified chart data
    var modifyChartData = function modifyChartData(data) {
        data['data'] = Object.prototype.hasOwnProperty.call(data, 'data') ? JSON.parse(data['data']) : null;
        return data;
    };

    // Add custom properties to original config
    var modifyTwobytwoConfigProperties = function modifyTwobytwoConfigProperties(config) {
        var Data = config.Data;

        // Initialize properties with empty strings if properties are null

        config.Data = modifyChartData(Data);
        return config;
    };

    // Remove unwanted properties, add custom properties and initialize null/undefined values
    var configBuilder = function configBuilder(config) {

        // Add common widget config properties
        config = widgetHelper.modifyWidgetConfigProperties(cloneDeep(config));

        // Add Twobytwo specific config properties
        config = modifyTwobytwoConfigProperties(cloneDeep(config));

        return config;
    };

    return {
        configBuilder: configBuilder
    };
};

export default twobytwoConfigBuilder();